import React, { Component } from "react";
import {Link} from "react-router-dom";


import gallery1Img from "../../../assets/images/gallary/autoblast/ASBM 6 Wheel.jpg"
import gallery2Img from "../../../assets/images/gallary/autoblast/ASBM.jpg"
import gallery3Img from "../../../assets/images/gallary/autoblast/Auto Shot Blast Machine.jpg"
import gallery4Img from "../../../assets/images/gallary/autoblast/Balsting Machine.jpg"
import gallery5Img from "../../../assets/images/gallary/autoblast/Belt_for_Bucket_Eleavtor-removebg-preview (2).png"
import gallery6Img from "../../../assets/images/gallary/autoblast/Blasting Machine2.jpg"
import gallery12Img from "../../../assets/images/gallary/autoblast/Wheel Unit Spares Parts.jpg"
import gallery13Img from "../../../assets/images/gallary/autoblast/Dispenser Housing  - Control Cage.jpg"
import gallery14Img from "../../../assets/images/gallary/autoblast/Dispenser.jpg"
import gallery15Img from "../../../assets/images/gallary/autoblast/Feed Chute.jpg"
import gallery16Img from "../../../assets/images/gallary/autoblast/Hooden Box for Wheel Unit & Abrasive Reservoir.jpg"
import gallery17Img from "../../../assets/images/gallary/autoblast/Impeller Wheel.jpg"
import gallery18Img from "../../../assets/images/gallary/autoblast/Wheel Blade.jpg"
import gallery19Img from "../../../assets/images/gallary/autoblast/Wheel Blades.jpg"
import gallery20Img from "../../../assets/images/gallary/autoblast/Wheel Hub.jpg"
import gallery21Img from "../../../assets/images/gallary/autoblast/Wheel Unit Spares -2.jpg"

import gallery7Img from "../../../assets/images/gallary/autoblast/D.C Bag.jpg"
import gallery8Img from "../../../assets/images/gallary/autoblast/D.C fan.jpg"
import gallery9Img from "../../../assets/images/gallary/autoblast/Dust Collector and Ducting.jpg"
import gallery10Img from "../../../assets/images/gallary/autoblast/Dust Collector Unit.jpg"
import gallery11Img from "../../../assets/images/gallary/autoblast/dust-collector-bag-filters.jpg"


import { SRLWrapper } from "simple-react-lightbox";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class Product1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:new Date(),
        };
    }
    changeDatepickerHandeller=(date)=>{
        this.setState({ startDate: date });
    }

    componentDidMount(){
        this.scrollTop();
    }

    scrollTop()
    {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
  render() {
        const startDate =this.state.startDate;

    return (
        <>
            {/* ===============  breadcrumb area start =============== */}
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="breadcrumb-wrap">
                                <h2>Auto Shot Blast Equipment / Dust Collector</h2>
                                <ul className="breadcrumb-links">
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}/`}>Home</Link>
                                        <i className="bx bx-chevron-right" />
                                    </li>
                                    <li>Auto Shot Blast Equipment / Dust Collector</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ===============  breadcrumb area end =============== */}
            <div className="package-details-wrapper pt-20">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="package-details">

                                <div className="package-tab">



                                    <div className="tab-content p-tab-content" id="pills-tabContent">
                                        <div className="tab-pane fade show active" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                                            <div className="tab-contant-3">
                                                <SRLWrapper>
                                                <div className="row">

                                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                                    <p><b>Auto Shot Blasting Machine</b></p>
                                                    <p>&bull; Manufacturing, Supply, Erection &amp;Commissioning of Auto Shot
Blasting Equipment</p>
                                                      <p>&bull; Dust Collectors / Extractors for Various Applications</p>
                                                        <p>&bull; Extractor Fans</p>
                                                          <p>&bull; 12-14% Wear Resistant ManganesePlates</p>
                                                             <p>&bull; Blast Room with Complete Recovery Unit</p>
                                                            <p>&bull; Complete range of Spare Parts for Auto Shot Blast Equipment</p>
<br/>
<p>Spare Parts consists of</p><br/>
<p>&bull; Impeller Wheel</p>
<p>&bull; Wheel Blade</p>
<p>&bull; Wheel Hub</p>
<p>&bull; Hooden Box Unit / Wheel Hood</p>
<p>&bull; Dispenser / Impeller</p>
<p>&bull; Dispenser Housing / Control Cage</p>
<p>&bull; Feed Chute / Feed Spout</p>
<p>&bull; Feed Chute Seal</p>
<p>&bull; Hub Seal</p>
<p>&bull; Hub Seal Housing Plate</p>
<p>&bull; Dispenser Housing Clamping Plate</p>
<p>&bull; Hood End Wear Plate / End Liner Plate</p>
<p>&bull; Top Curved Wear Plate</p>
<p>&bull; Bottom Side End Wear Plate</p>
<p>&bull; Top Side Radius Wear Plate</p>
<p>&bull; Dust Collector Filter Bags</p>
<p>&bull; Filter Cartridges</p>
<p>&bull; Industrial Ducting Units</p>
<p>&bull; Manganese Wear Plates</p>
<p>&bull; Hi-Chrome Dome Nuts</p><br/>

                                                    <h4>Auto Blast Equipment</h4>
                                                             <Link to={gallery1Img} >
                                                                    <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery1Img} alt="ASBM 6 Wheel" />
                                                                </Link>

                                                                <Link to={gallery2Img} >
                                                                       <img width="150" height="150" style={{marginRight:10, marginTop:10}}  src={gallery2Img} alt="ASBM" />
                                                                   </Link>

                                                                   <Link to={gallery3Img} >
                                                                          <img width="150" height="150" style={{marginRight:10, marginTop:10}}src={gallery3Img} alt="Auto Shot Blast Machine" />
                                                                      </Link>

                                                                      <Link to={gallery4Img} >
                                                                             <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery4Img} alt="Balsting Maching" />
                                                                         </Link>

                                                                         <Link to={gallery5Img} >
                                                                                <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery5Img} alt="Belt_for_Bucket_Eleavtor" />
                                                                            </Link>

                                                                            <Link to={gallery6Img} >
                                                                                   <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery6Img} alt="Blasting Machine" />
                                                                               </Link>



                                                                                              <Link to={gallery12Img} >
                                                                                                     <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery12Img} alt="Wheel Unit Spares Parts" />
                                                                                                 </Link>

                                                                                                 <Link to={gallery13Img} >
                                                                                                        <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery13Img} alt="Dispenser Housing - Control Cage" />
                                                                                                    </Link>

                                                                                                    <Link to={gallery14Img} >
                                                                                                           <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery14Img} alt="Dispenser" />
                                                                                                       </Link>

                                                                                                       <Link to={gallery15Img} >
                                                                                                              <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery15Img} alt="Autoblast/Feed Chute" />
                                                                                                          </Link>

                                                                                                          <Link to={gallery16Img} >
                                                                                                                 <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery16Img} alt="Hooden Box for Wheel Unit & Abrasive Reservoir" />
                                                                                                             </Link>

                                                                                                             <Link to={gallery17Img} >
                                                                                                                    <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery17Img} alt="Impeller Wheel" />
                                                                                                                </Link>

                                                                                                                <Link to={gallery18Img} >
                                                                                                                       <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery18Img} alt="Wheel Blade" />
                                                                                                                   </Link>

                                                                                                                   <Link to={gallery19Img} >
                                                                                                                          <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery19Img} alt="Wheel Blades" />
                                                                                                                      </Link>

                                                                                                                      <Link to={gallery20Img} >
                                                                                                                             <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery20Img} alt="Wheel Hub" />
                                                                                                                         </Link>

                                                                                                                         <Link to={gallery21Img} >
                                                                                                                                <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery21Img} alt="Wheel Unit Spares" />
                                                                                                                            </Link>

                                                                                                                            <p></p>



                                                    </div>
                                                    <h4 style={{marginTop:50}}>Dust Collector</h4>
  <div className="col-lg-12 col-md-12 col-sm-12">
                                                    <Link to={gallery7Img} >
                                                           <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery7Img} alt="D.C Bag" />
                                                       </Link>

                                                       <Link to={gallery8Img} >
                                                              <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery8Img} alt="D.C Fan" />
                                                          </Link>

                                                          <Link to={gallery9Img} >
                                                                 <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery9Img} alt="Dust Collector and Ducting" />
                                                             </Link>

                                                             <Link to={gallery10Img} >
                                                                    <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery10Img} alt="Dust Collector Unit" />
                                                                </Link>

                                                                <Link to={gallery11Img} >
                                                                       <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery11Img} alt="Dust Collector Bag Filters" />
                                                                   </Link>

                                                                     </div>

                                                </div>
                                                </SRLWrapper><br/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
  }
}

export default Product1;
